export default __webpack_public_path__ + "static/media/logo.606701bd.webp";